import {
    CREAR_PACIENTE,
    CREAR_PACIENTE_EXITO,
    CREAR_PACIENTE_ERROR
} from '../types';
import { cargarPacientesScreeningAction } from './cargarPacientesScreeningActions';
import clienteAxios from '../config/axios';

// Mando al store los datos de residencia
export function crearPacienteScreeningAction(informacion) {
    return async (dispatch) => {
        dispatch( crearPacienteScreening() );
        try {
            const {config, payload} = informacion;
            const respuesta = await clienteAxios.post('/paciente/crearpacientescreening', payload,config);
            dispatch( crearPacienteScreeningExito(respuesta.data.msg) );
            dispatch (cargarPacientesScreeningAction(informacion));
        } catch (error) {
            const errores = error.response;
            if (errores !== undefined) {
                dispatch( crearPacienteScreeningError(error.response.data) );
            }
        }
    }
}

const crearPacienteScreening = () => ({
    type: CREAR_PACIENTE,
    payload: true
});
const crearPacienteScreeningExito = (msg) => ({
    type: CREAR_PACIENTE_EXITO,
    payload: msg
});
const crearPacienteScreeningError = (msg) => ({
    type: CREAR_PACIENTE_ERROR,
    payload: msg
});